import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';

export function useTags(search: string) {
  return useQuery(allocationQueries.tags(search));
}
